import React, { useState } from "react";
import { Star, Plus } from "lucide-react";
import { SERVICES } from "../../data/constants";
import ServiceCard from "../ServiceCard";
import ServiceDetailDialog from "../ServiceDetailDialog";

export default function ServicesSection() {
  const [active, setActive] = useState(null);
  const [open, setOpen] = useState(false);

  const handleOpen = (svc) => {
    setActive(svc);
    setOpen(true);
  };

  const primary = SERVICES.filter((s) => s.tier === "primary");
  const secondary = SERVICES.filter((s) => s.tier !== "primary");

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative border-b border-white/10 bg-[#0B0F19]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-24 md:py-32">
        {/* Header */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20 items-end">
          <div className="md:col-span-7">
            <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-[#F47B20] mb-4">
              / 03 — Services
            </p>
            <h2 className="font-display font-black uppercase tracking-tighter text-white text-4xl sm:text-5xl md:text-6xl leading-[0.95]">
              Specialist in <span className="text-[#F47B20]">ERP + integrations.</span>{" "}
              <br className="hidden sm:block" />
              Full-stack on demand.
            </h2>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-white/65 text-base leading-relaxed">
              We lead with deep specialisation in NetSuite, Odoo and Celigo —
              and round it out with websites and brand collateral so you have
              one accountable team across the full GTM stack.
            </p>
          </div>
        </div>

        {/* Primary specialisation */}
        <div className="mb-6 flex items-center gap-3">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#F47B20] text-black text-[10px] font-bold uppercase tracking-[0.3em]">
            <Star className="w-3 h-3" strokeWidth={2.6} fill="currentColor" />
            Primary Specialisation
          </span>
          <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/45">
            Where we deliver deep, certified expertise
          </span>
        </div>
        <div
          data-testid="services-primary"
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-16 md:mb-20"
        >
          {primary.map((svc) => (
            <ServiceCard key={svc.id} service={svc} onOpen={handleOpen} />
          ))}
        </div>

        {/* Divider */}
        <div className="flex items-center gap-4 mb-6">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/20 text-white/80 text-[10px] font-bold uppercase tracking-[0.3em]">
            <Plus className="w-3 h-3" strokeWidth={2.6} />
            Also Offered
          </span>
          <span className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/45">
            Full-stack support to extend your wins
          </span>
        </div>
        <div
          data-testid="services-secondary"
          className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8"
        >
          {secondary.map((svc) => (
            <ServiceCard key={svc.id} service={svc} onOpen={handleOpen} />
          ))}
        </div>
      </div>

      <ServiceDetailDialog service={active} open={open} onOpenChange={setOpen} />
    </section>
  );
}
